<script>
  import Scroller from 'svelte-scroller';
  import GraphicFCC from './Spectrum.svelte';
  export let isEmbedded = false;
  export let googleDoc = {};
  export let allData = {};
  export let type = 'spectrum';

  import { onMount } from 'svelte';
  let index, offset, progress;
  let width = 100;
  let ready = false;

  onMount(() => {
    ready = true;
  });
</script>

<style type="text/scss">section {
  height: 110vh; }
  @media only screen and (min-width: 860px) {
    section {
      height: 100vh; } }
  section.first {
    height: 20vh; }
    @media only screen and (min-width: 860px) {
      section.first {
        height: 25vh; } }
  @media only screen and (min-width: 860px) {
    section.last {
      height: 50vh; } }

.textArea {
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  padding: 15px;
  border: 1px solid #000;
  max-width: 420px;
  margin: 0 auto; }
  @media only screen and (min-width: 860px) {
    .textArea {
      width: 50%;
      padding: 0;
      margin-left: calc(50% + 20px);
      border: none;
      background: none; } }
  .textArea div {
    white-space: break-spaces; }

.drop-shadow {
  box-shadow: rgba(0, 0, 0, 0.2) 2px 4px 6px 0px; }
  @media only screen and (min-width: 860px) {
    .drop-shadow {
      box-shadow: none; } }

[slot='background'] {
  height: 100vh; }

.measure {
  width: 100%; }
</style>

<div class="measure" bind:offsetWidth={width} />
<Scroller
  {isEmbedded}
  bind:index
  bind:offset
  bind:progress
  threshold={width > 860 ? 0.8 : 0.5}
  query="section.active">
  <div slot="background">
    {#if ready}
      <GraphicFCC {allData} {index} {type} {googleDoc} showButtons={false} />
    {/if}
  </div>

  <div slot="foreground">
    <section class="first " />

    {#each googleDoc.scrolltext as block, i}
      <div class="textArea drop-shadow">

        <div>
          <p>
            {@html block.Text}
          </p>
        </div>

      </div>
      <section
        class="active {i == googleDoc.scrolltext.length - 1 ? 'last' : ''}" />
    {/each}

  </div>
</Scroller>
